export function hoverCta1(view = '')
{
    if(view === '') return false
    for(let $btn of view.querySelectorAll('.btn-cta1')) {
        $btn.timer = false
        $btn.addEventListener('mouseenter',()=>{
            clearTimeout($btn.timer)
            $btn.classList.remove('is--hovered')
            $btn.timer = setTimeout(() => {
                $btn.classList.add('is--hovered')
            }, 350);
        })
        $btn.addEventListener('mouseleave',()=>{
            $btn.timer = setTimeout(() => {
                $btn.classList.remove('is--hovered')
            }, 350);
        })
    }
}